const PREFERRED_FOCUS_MODES = ["continuous", "auto", "single-shot"] as const;

type FocusCapabilities = MediaTrackCapabilities & {
  focusMode?: string[];
};

type FocusConstraintSet = MediaTrackConstraintSet & {
  focusMode?: string;
};

export async function enableCameraAutofocus(stream: MediaStream): Promise<void> {
  const track = stream.getVideoTracks()[0];
  if (!track?.getCapabilities) return;

  const { focusMode } = track.getCapabilities() as FocusCapabilities;
  if (!Array.isArray(focusMode) || focusMode.length === 0) return;

  const mode =
    PREFERRED_FOCUS_MODES.find((candidate) => focusMode.includes(candidate)) ??
    focusMode[0];

  try {
    await track.applyConstraints({
      advanced: [{ focusMode: mode } as FocusConstraintSet],
    });
  } catch {
    // Some devices expose focusMode but reject applyConstraints.
  }
}
